document.addEventListener("DOMContentLoaded", () => {
  const sostituto =
    "Seleziona Anellina <i class='po-dropdown-arrow po-dropdown-arrow-down'></i>";
  const sostitutoDrop = "<span>Seleziona Anellina</span>";

  let tentativi = 0;
  const maxTentativi = 50; // es. 5 secondi a 100ms

  const checker = setInterval(() => {
    const dropDownDefault = document.querySelector(
      "#bss-po-dropdown-selected-option"
    );
    const elementDefault = document.querySelector(
      "#bss-po_dropdown798807 > div.po-dropdown-list > div.bss_scroll > div.po-dropdown-option.po-value.selected"
    );

    if (dropDownDefault && dropDownDefault.innerHTML !== sostituto) {
      dropDownDefault.innerHTML = sostituto;
    }

    if (elementDefault && elementDefault.innerHTML !== sostitutoDrop) {
      elementDefault.innerHTML = sostitutoDrop;
    }

    if (
      dropDownDefault &&
      elementDefault &&
      dropDownDefault.innerHTML === sostituto &&
      elementDefault.innerHTML === sostitutoDrop
    ) {
      console.log("Sostituzione completata.");
      clearInterval(checker);
    }

    if (++tentativi > maxTentativi) {
      console.warn("Elemento non trovato o non modificabile.");
      clearInterval(checker);
    }
  }, 100);
});
